import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SelectableMenuItem } from "../../../../components/Menu";
import { Actions, Channel, Topic } from "../../../../constants";
import { LocalizationMessages } from "../../../../localization/messages";
import { MessageBrokerUtils, NavigationUtils } from "../../../../utils";
import { UserContextSelectors } from "../../../../redux/selectors";
import { TicketsRedDot } from "../../../../components/RedDot/TicketsRedDot";
import { UserContextActionCreators } from "../../../../redux/action-creators";

const LoyaltySection = () => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const dispatch = useDispatch();

  const items = {
    tickets: {
      title: LocalizationMessages.tickets_Poker,
      iconKey: "ticket",
      onClick: () => {
        const tabId = 10;
        if (isAuthenticated) {
          openMyAccountByTabId(tabId);
          dispatch(UserContextActionCreators.allTicketsSeen());
          return;
        }

        const data = {
          actionID: Actions.openMyAccount,
          actionData: { TabId: tabId }
        };
        NavigationUtils.runFlowRunner(data);
      }
    },
    freeSpins: {
      title: LocalizationMessages.freeSpins_Poker,
      iconKey: "freespin",
      onClick: () => {
        const campaignId = -1;
        if (isAuthenticated) {
          openRich(campaignId);
          return;
        }

        const data = {
          actionID: Actions.openRich,
          actionData: { CampaignId: campaignId }
        };
        NavigationUtils.runFlowRunner(data);
      }
    },
    blastLeaderboards: {
      title: LocalizationMessages.blast_LeaderBoard_Poker,
      iconKey: "flag",
      onClick: () => {
        const tabId = 15;
        if (isAuthenticated) {
          openMyAccountByTabId(tabId);
          return;
        }

        const data = {
          actionID: Actions.openMyAccount,
          actionData: { TabId: tabId }
        };
        NavigationUtils.runFlowRunner(data);
      }
    }
  };

  const openMyAccountByTabId = tabId => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.CTA_MyAccount_Open,
      headers: {
        publisher: "UAA"
      },
      data: {
        tabId: tabId
      }
    });
  };

  const openRich = campaignId => {
    MessageBrokerUtils.publish({
      channel: Channel.CRM,
      topic: Topic.CTA_RICH_Open,
      headers: {
        publisher: "UAA"
      },
      data: {
        CampaignId: campaignId
      }
    });
  };

  return (
    <>
      <SelectableMenuItem
        item={items.tickets}
        dataTestId="uc-tournamentTickets"
        disableClickStyles={true}
        onClick={items.tickets.onClick}
      >
        <TicketsRedDot dataTestId="uc-loyalty-dot" />
      </SelectableMenuItem>
      <SelectableMenuItem
        item={items.blastLeaderboards}
        dataTestId="uc-blastLeaderBoard"
        disableClickStyles={true}
        onClick={items.blastLeaderboards.onClick}
      />
    </>
  );
};

export default React.memo(LoyaltySection);
